<template>
  <div>
    <div class="w100 cj clearfix">
      <div class="title">
        <h4>应用场景</h4>
        <slot></slot>
      </div>
      <div class="container" id="cj">
        <div
          v-for="(item, index) in list "
          :key="index"
          class="cjapply"
          :style="{ background: 'url(' + require('../../assets/' + item['img']) + ') no-repeat center center', backgroundSize: '100% 100%'}"
        >
          <p v-for="(ite, ind) in item['context']" :key="ind">{{ite}}</p>
          <span class="line_wh" v-if="item['context'].length>0"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'suitCase',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
#cj p {
  font-size: 18px;
  font-weight: 500;
  color: rgba(254, 254, 254, 1);
  line-height: 47px;
  margin-top: -26px;
}
.cjapply {
  background-size: 100% 100%;
  width: 47.6%;
  height: 264px;
  padding-top: 105px;
  margin: 0;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/common/suitCase.vue